<template>
  <div>
    <v-dialog v-model="work_Proof" persistent width="390px">
      <v-card class="overflow-hidden">
        <v-toolbar dense class="gradient-bg elevation-0"
          ><v-toolbar-title class="white--text"
            >Proof of Work - {{ this.userObject.user_name }}</v-toolbar-title
          >
          <v-spacer />
          <v-icon @click="close_dialog()" class="white--text mr-n2"
            >mdi-close</v-icon
          >
        </v-toolbar>

        <v-card-text
          v-if="isFailed"
          class="d-flex flex-column align-center justify-center text-center py-10"
        >
          <v-avatar size="80" class="mb-4 grey lighten-4">
            <v-icon size="40" color="red lighten-1">
              mdi-file-alert-outline
            </v-icon>
          </v-avatar>

          <div class="text-h6 font-weight-medium grey--text text--darken-2">
            {{ apiMessage }}
          </div>

          <div class="caption grey--text mt-2">
            No proof of work was submitted for this swipe.
          </div>
        </v-card-text>

        <v-card-text
          v-else-if="!isFailed"
          align="center"
          style="font-weight: bold; text-align: justify"
        >
          <!-- true -->
          <v-text-field
            label="Working Type"
            v-model="worktype"
            dense
            readonly
            outlined
            class="mt-4 mr-4 ml-2"
          ></v-text-field>
          <v-textarea
            label="Work Notes"
            v-model="comment_work"
            dense
            readonly
            outlined
            class="mt-n2 mr-4 ml-2"
          ></v-textarea>
          <div
            style="border: 1px solid gray; width: fit-content"
            class="ml-2"
            v-if="images == null"
          >
            <v-img height="145" width="320"
              ><v-container class="fill-height d-flex justify-center" fluid>
                <span>No - Image</span>
              </v-container>
            </v-img>
          </div>
          <div v-if="images != null">
            <v-card max-width="320" class="ml-2" flat>
              <v-carousel
                v-model="model"
                height="200px"
                hide-delimiters
                :show-arrows="false"
                v-if="images.length == 1"
              >
                <v-carousel-item
                  v-for="images1 in images"
                  :key="images1"
                  :src="images1"
                >
                </v-carousel-item>
              </v-carousel>
              <v-carousel
                v-model="model"
                height="200px"
                width="100px"
                hide-delimiters
                v-else
              >
                <v-carousel-item
                  v-for="images1 in images"
                  :key="images1"
                  :src="images1"
                >
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TextField from "@/components/FormDesigner/FormFields/TextField.vue";
// import NumberField from "@/components/FormDesigner/FormFields/NumberField.vue";
import CheckboxField from "@/components/FormDesigner/FormFields/CheckboxField.vue";
import TextAreaField from "@/components/FormDesigner/FormFields/TextAreaField.vue";
// import DateField from "@/components/FormDesigner/FormFields/DateField.vue";
// import DropdowmField from "@/components/FormDesigner/FormFields/DropdowmField.vue";
// import TimePicker from "@/components/FormDesigner/FormFields/TimePicker.vue";
import RatingFile from "@/components/FormDesigner/FormFields/RatingFile.vue";
import DividerComp from "@/components/FormDesigner/FormFields/DividerComp.vue";
import FlipSwitch from "@/components/FormDesigner/FormFields/FlipSwitch.vue";
import LabelField from "@/components/FormDesigner/FormFields/LabelField.vue";
import { API, graphqlOperation } from "aws-amplify";
import { getFormData } from "@/graphql/queries.js";
export default {
  props: {
    work_Proof: Boolean,
    userObject: Object,
  },
  components: {
    TextField,
    // NumberField,
    CheckboxField,
    TextAreaField,
    // DateField,
    // DropdowmField,
    // TimePicker,
    RatingFile,
    DividerComp,
    FlipSwitch,
    LabelField,
  },
  data: () => ({
    worktype: "",
    model: 0,
    comment_work: "",
    formActionType: "previewproof",
    images: "",
    formFields: [],
    apiMessage: "",
    isFailed: false,
  }),

  watch: {
    work_Proof: {
      immediate: true, // 👈 IMPORTANT
      handler(val) {
        if (val && this.userObject?.swipe_id) {
          console.log(this.userObject);
          this.get_details();

          // this.formFields = [];
          // this.worktype = this.userObject.forms?.working_type || "";
          // this.comment_work = this.userObject.forms?.working_comments || "";
          // this.images = this.userObject.forms?.working_field_keys || null;

          // this.formFields = (this.userObject.forms?.form_template || []).map((x) => {
          //   return {
          //     type: x.data_type,
          //     value: x.data_type === "rating" ? +x.value : x.value,
          //     displayLabel: x.display_label,
          //     ...x,
          //   };
          // });
        }
      },
    },
  },

  methods: {
    close_dialog() {
      this.formFields = [];
      // console.log(this.userObject.forms, "userObject");
      this.$emit("clicked", 0);
    },
    async get_details() {
      try {
        const res = await API.graphql(
          graphqlOperation(getFormData, {
            input: {
              swipe_id: this.userObject.swipe_id,
            },
          })
        );

        const parsedResponse = JSON.parse(res?.data?.getFormData || "{}");

        console.log("Parsed response:", parsedResponse);

        // ✅ If Failed
        if (parsedResponse.Status === "Failed") {
          this.isFailed = true;
          this.apiMessage = parsedResponse.Message || "No Form Submitted";

          // Clear previous data
          this.worktype = "";
          this.comment_work = "";
          this.images = null;
          this.formFields = [];

          return;
        }

        // ✅ If Success
        if (parsedResponse.Status === "SUCCESS") {
          this.isFailed = false;
          this.apiMessage = "";

          const ScanLogsItems = parsedResponse.data || {};

          this.worktype = ScanLogsItems.working_type || "";
          this.comment_work = ScanLogsItems.working_comments || "";
          this.images = ScanLogsItems.working_field_keys || null;

          this.formFields = (ScanLogsItems.form_template || []).map((x) => {
            return {
              type: x.data_type,
              value: x.data_type === "rating" ? +x.value : x.value,
              displayLabel: x.display_label,
              ...x,
            };
          });
        }
      } catch (err) {
        console.log("Error:", err);
        this.isFailed = true;
        this.apiMessage = "Something went wrong";
      }
    },
  },
};
</script>

<style>
</style>